import { useEffect, useState } from "react";
import { ListChecks } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const WishlistsSection = () => {
  const [lists, setLists] = useState(null);

  useEffect(() => {
    fetch(`${API}/wishlists`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : Promise.reject()))
      .then((d) => setLists(d.wishlists || []))
      .catch(() => setLists("error"));
  }, []);

  return (
    <section data-testid="dashboard-wishlists">
      <h2 className="flex items-center gap-3 font-display text-2xl font-medium text-ink">
        <ListChecks className="h-5 w-5 text-jade" /> Build wishlists
      </h2>
      {lists === null && <p className="mt-4 text-sm text-ink2">Loading wishlists…</p>}
      {lists === "error" && <p className="mt-4 text-sm text-red-700" data-testid="wishlists-error">Couldn't load wishlists. Please refresh.</p>}
      {Array.isArray(lists) && lists.length === 0 && (
        <p className="mt-4 rounded-2xl bg-white p-6 text-sm leading-relaxed text-ink2 shadow-ambient">
          No wishlists yet. Lists sent from the Build your own picker appear here.
        </p>
      )}
      {Array.isArray(lists) && lists.length > 0 && (
        <ul className="mt-5 space-y-3" data-testid="wishlists-list">
          {lists.map((w, i) => (
            <li key={i} className="rounded-2xl bg-white p-6 shadow-ambient" data-testid="wishlist-item">
              <div className="flex flex-wrap items-baseline justify-between gap-2">
                <p className="font-medium text-ink">
                  {w.name} <a href={`mailto:${w.email}`} className="ml-2 text-sm text-jade underline-offset-4 hover:underline">{w.email}</a>
                </p>
                <span className="text-xs text-ink2/50">{new Date(w.created_at).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })}</span>
              </div>
              <p className="mt-3 text-sm text-ink2">
                {w.build} build · {w.care_plan} care plan
                {w.features?.length > 0 && ` · ${w.features.map((f) => f.label).join(", ")}`}
              </p>
              {w.note && <p className="mt-2 whitespace-pre-wrap text-sm text-ink2/80">{w.note}</p>}
              <p className="mt-3 text-sm font-medium text-jade" data-testid={`wishlist-totals-${i}`}>
                {w.one_off_total} one-off · £{w.monthly_total}/mo
              </p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
